import { IUhubErrorResponse } from 'types/Project'

const briefErrorMapper = (error?: IUhubErrorResponse): string =>
  Object.values(error?.errors ?? {})
    .map(err => err)
    .join(', ')

export default briefErrorMapper
